module.exports = __webpack_public_path__ + "img/nodataInfo.e793fb2e.svg";